export default __webpack_public_path__ + "static/media/black-close-button.76ef43f0.svg";